//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ### STYLES ###
import { Box, TextField, Button, Link } from '@mui/material';

// === API ===
import { requestPasswordResetViaEmail } from 'api/prokey/prokey.axios';

//#endregion

//-----------------------------------------------------------------
export function PassForgotForm() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();

  const [user_email , setUserEmail] = useState('');
  const [alert_info , setAlertInfo] = useState({ style: [], message: '' });

  const email_regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
  const error_message_default = 'Unable to reset password, please contact your administrator';

  //#endregion

  //#region [STYLES]

  const _styles = {
    alert: {
      display          : 'inline-block',
      color            : 'white',
      marginTop        : '1rem',
      padding          : '1rem',
      width            : '100%',
      borderRadius     : '4px',
    },
    hidden: {
      display: 'none',
    },
    failure: {
      backgroundColor: 'darkred',
    },
    success: {
      backgroundColor: 'darkgreen',
    },

    email: {
      width  : '100%'   ,
      margin : '0.5rem' ,
    },

    sign_in_container: {      
      width     : '100%'         ,
      marginTop : '0.75rem'      ,
      display   : 'inline-block' ,
    },
    SEND_EMAIL_BUTTON: {
      marginLeft: '1rem',
    }
  }

  // === PROPS ===

  const _props = {
    ALERT: {
      sx: alert_info.style,
      children: [alert_info.message]
    },

    EMAIL: {
      name       : 'email_txt'      ,
      type       : 'username'       ,
      variant    : 'filled'         ,
      sx         : _styles.email    ,
      label      : 'email'          ,
      value      : user_email       ,
      autoFocus  : true             ,
      onFocus    : clearAlert       ,
      onKeyPress : handleKeyPress   ,
      onChange   : (e) => setUserEmail(e.target.value),
    },

    GO_BACK_LINK: {
      name      : 'go_back_link',
      component : 'button',
      onClick   : handleGoBack,
      children  : ['Back to login'],
    },
    SEND_EMAIL_BUTTON: {
      name      : 'send_email_btn',
      sx       : _styles.SEND_EMAIL_BUTTON,
      variant  : 'contained'    ,
      color    : 'primary'      ,
      onClick  : postLogin      ,
      children : ['Send Email'] ,
    }
  }

  //#endregion

  //#region [EVENTS]

//-----------------------------------------------------------------
  async function postLogin() {
    //-----------------------------------------------------------------
    try {
      clearAlert();

      if (!email_regex.test(user_email)) {
        setAlertInfo( { style: [_styles.alert, _styles.failure], message: 'Please provide a valid email address' } );
        return;
      } 

      const result = await requestPasswordResetViaEmail( { email: user_email } );
      
      if( result.status !== 200 ) throw result.status;

      setAlertInfo( { style: [_styles.alert, _styles.success], message: 'Email Sent!' } );
      setTimeout(handleGoBack, 3000);

    } catch (error) {
      setAlertInfo( { style: [_styles.alert, _styles.failure], message: error_message_default } );
    }
  }

  //-----------------------------------------------------------------
  function handleKeyPress(target) {
    //-----------------------------------------------------------------
    if (target.charCode === 13) postLogin();
  }

  //-----------------------------------------------------------------
  function handleGoBack() {
    //-----------------------------------------------------------------
    navigate( '../' );
  }

  //-----------------------------------------------------------------
  function clearAlert() {
    //-----------------------------------------------------------------
    setAlertInfo( {style: [_styles.hidden], message: ''} );
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={ _styles.container }>
        <TextField {..._props.EMAIL} />
        <Box sx={ _styles.sign_in_container }>
          <Link {..._props.GO_BACK_LINK}  />
          <Button {..._props.SEND_EMAIL_BUTTON } />
        </Box>
        <Box {..._props.ALERT}/>
      </Box>
    );
  }

  //#endregion

  return display();
}
